import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { GiftCardTransactionFragment } from '@/gql/generated';
import { formatDateToTimezone } from '@/lib/timezone';
import { formatNumberToCurrency } from '@/lib/utils';
import { GiftCardTransactionType } from '@/types/gift-card-check-code/graphql/type-gift-card.constant';
import clsx from 'clsx';

const TableDesktop = ({
  transactions,
  timeZone,
}: {
  transactions: GiftCardTransactionFragment[];
  timeZone: string;
}) => {
  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>NO.</TableHead>
            <TableHead>Order Id</TableHead>
            <TableHead>Transaction</TableHead>
            <TableHead>Balance</TableHead>
            <TableHead>Date</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {transactions.map((transaction, index) => (
            <TableRow key={transaction.dts_order_id}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{transaction.dts_order_id}</TableCell>
              <TableCell className="font-bold">
                <div
                  className={clsx(
                    '',
                    transaction.type === GiftCardTransactionType.TOP_UP
                      ? 'text-[#13BC8E]'
                      : '',
                  )}
                >
                  {transaction.type === GiftCardTransactionType.TOP_UP
                    ? '+'
                    : '-'}
                  {formatNumberToCurrency(transaction.balance_change)}
                </div>
              </TableCell>
              <TableCell className="font-bold">
                {formatNumberToCurrency(transaction.balance_after)}
              </TableCell>
              <TableCell>
                {transaction.date
                  ? formatDateToTimezone(
                      transaction.date,
                      timeZone,
                      'LLL d, yyyy hh:mm a',
                    )
                  : ''}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default TableDesktop;
